import { ChatBubbleOutline } from '@mui/icons-material';
import { Button, ButtonProps, IconButton, IconButtonProps, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from 'shared/hooks';

type FeedbackIconButtonProps = Pick<IconButtonProps & ButtonProps, 'onClick' | 'sx'>;

export default function FeedbackIconButton(props: FeedbackIconButtonProps) {
    const { t } = useTranslation('feedback');
    const isMobile = useIsMobile();
    const label = t('button.leaveFeedback');

    if (isMobile) {
        return (
            <IconButton size="small"
                color="inherit"
                aria-label={ label }
                { ...props }
            >
                <ChatBubbleOutline fontSize="small" />
            </IconButton>
        );
    }

    return (
        <HighlightedButton size="small"
            color="inherit"
            variant="text"
            endIcon={ <ChatBubbleOutline /> }
            { ...props }
        >
            { label }
        </HighlightedButton>
    );
}

const HighlightedButton = styled(Button)({
    textDecoration: 'underline',
    '&:hover': {
        textDecoration: 'underline'
    },

    '& .MuiButton-endIcon>*:nth-of-type(1)': {
        fontSize: '1rem'
    }
});
